import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { API } from '../config/api';
import { environment } from '../../../environments/environment';
import { LoginRequestModel } from './login.model';
import { tap } from 'rxjs/operators';
import { BoSpinnerService } from 'src/@core/shared';

@Injectable()
export class LoginService {
    public baseUrl = environment.baseUrl;
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService
        ) {
        }
    public login(request: LoginRequestModel): Observable<any> {
        this._spinner.show(true);
        return this._http.post(this.baseUrl + `${API.LOGIN.TOKEN}`, request)
        .pipe(tap(() => this._spinner.hide()));
    }
    public firstLogin(): Observable<any> {
        return this._http.get(this.baseUrl + `${API.LOGIN.FIRST_LOGIN}`);
    }
    public forgotPassword(email: string): Observable<any> {
        return this._http.get(this.baseUrl + `${API.LOGIN.FORGOT_PASSWORD}/` + email);
    }
}
